import AjaxPanel from './AjaxPanel'

AjaxPanel.install = function install (Vue) {
  Vue.component(AjaxPanel.name, AjaxPanel)
}

export default AjaxPanel



// WEBPACK FOOTER //
// ./src/components/ajax-panel/index.js